export default __webpack_public_path__ + "static/media/lab_carousel_6.png";